import { entries } from '@wix/wix-data-client-common-standalone'
import { FieldType, type Schema } from '@wix/wix-data-schema-types'

export const getItemPageFieldKey = ({
  fields,
  displayFieldKey,
}: {
  fields: Schema['fields']
  displayFieldKey: string
}): string | null => {
  const itemPagePatternRegExp = new RegExp(`^/[^/]+/{${displayFieldKey}}$`)
  return (
    entries(fields).find(
      ([, field]) =>
        !field.isDeleted &&
        field.type === FieldType.pageLink &&
        field.calculator?.config.pattern !== undefined &&
        itemPagePatternRegExp.test(field.calculator.config.pattern),
    )?.[0] ?? null
  )
}
